import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const CustomDropdown = (props) => {
  const {
    multiple = false,
    label = '',
    value,
    options = [],
    disabled = false,
    readOnly = false,
    placeholder = '',
    error = false,
    helperText = '',
    onChange,
    isLock = false,
    isReadOnly = false,
    renderOptionKey = false,
    isLabel = false,
    sx = {},
    inValidValues = [],
  } = props;

  const getOptionLabel = (option) =>
    typeof option === 'string'
      ? option
      : renderOptionKey
        ? option?.[renderOptionKey] ?? ''
        : typeof option === 'object'
          ? JSON.stringify(option)
          : '';

   // ✅ check if current value is invalid
  const isInvalid = React.useMemo(() => {
    if (!value) return false;

    if (multiple && Array.isArray(value)) {
      return value.some((v) => inValidValues.includes(v));
    }
    return inValidValues.includes(value);
  }, [value, multiple, inValidValues]);

  const isError =  isInvalid;

  return (
    <Autocomplete
      multiple={multiple}
      options={options}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, val) =>
        renderOptionKey
          ? option?.[renderOptionKey] === val?.[renderOptionKey]
          : option === val
      }
      value={value || (multiple ? [] : null)}
      readOnly={readOnly || isReadOnly}
      disabled={disabled || isLock}
      onChange={(_, newValue) => {
        if (onChange) {
          onChange(newValue);
        }
      }}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          ...(isError && {
            "& fieldset": {
              borderColor: "error.main",
            },
            "&:hover fieldset": {
              borderColor: "error.dark",
            },
            "&.Mui-focused fieldset": {
              borderColor: "error.dark",
            },
          }),
        },
        ...sx,
      }}
      // sx={{
      //   width: '100%',
      //   ...sx,
      // }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={isLock ? "Lock" : isLabel ? label : null}
          placeholder={placeholder}
          variant="outlined"
          error={error}
          helperText={helperText}
          disabled={disabled || isLock}
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          key={renderOptionKey ? option?.[renderOptionKey] : option}
          value={renderOptionKey ? option?.[renderOptionKey] : option}
        >
          {renderOptionKey ? option?.[renderOptionKey] : getOptionLabel(option)}
        </li>
      )}
    />
  );
};

export default CustomDropdown;